import { JsonObject, JsonProperty, JsonType } from "ta-json";

import type { Nullable } from "../base-types";
import Link from "../link";
import Resource from "./resource";

@JsonObject()
export abstract class ListResource<T extends Resource> extends Resource {
    abstract items: Array<T>;

    @JsonProperty("total_items")
    totalItems?: Nullable<number>;

    @JsonProperty("returned_items")
    returnedItems?: Nullable<number>;

    @JsonProperty("offset")
    offset?: Nullable<number>;

    @JsonProperty("next")
    @JsonType(Link)
    next: Nullable<Link>;

    @JsonProperty("previous")
    @JsonType(Link)
    previous: Nullable<Link>;

    @JsonProperty("identifier")
    identifier: Nullable<string>;

    [key: string]: unknown; //TODO extension data
}
